import { useTranslation } from 'react-i18next';

export default function getNavigationLinks() {
  const { t } = useTranslation();
  return [
    { name: t('Sales'), href: `/workspace/sales`, id: 'workspace-sales' },
    // { name: t('Communications'), href: `/workspace/communication`, id: 'workspace-communications' },
    // { name: t('Steward'), href: `/workspace/steward`, id: 'workspace-steward' },
    // { name: t('Administrator'), href: `/workspace/admin`, id: 'workspace-admin' },
  ];
}
